import React, { useState } from 'react'
import CommonHeader from './../CommonHeader'
import CreatableSelector from './../CreatableSelector'
import ProductRichTextEditor from './'
import { message, Typography } from 'antd'
import { updateImageText } from '@services/productService'
import ImageTextAdapter from './imageTextAdapter'
const { Paragraph } = Typography

const imageTextAdapter = new ImageTextAdapter()

function ProductRichTextSection (props: any) {
  const { readOnly = false, productId, initialValue, legacyValue } = props
  const [pids, setProductIds] = useState<any[]>([])
  const [value, onChange] = useState(imageTextAdapter.deserialize(initialValue || legacyValue))
  const onSave = () => {
    if (readOnly) return
    const data = imageTextAdapter.serialize(value)
    if (!data || !Array.isArray(data.layers)) return
    const hide = message.loading('更新中...')
    updateImageText([productId].concat(pids?.map((p: any) => p.value)).filter(id => id), data)
      .then(res => {
        hide()
        message.success('更新图文详情成功')
      })
      .catch(error => {
        hide()
        console.error(error)
        message.error('更新图文详情失败')
      })
  }
  console.log(legacyValue)
  return (
    <div>
      {!readOnly && (
        <>
          <Paragraph>小编点评(拖拽/复制图片到输入框试试): </Paragraph>
          <CommonHeader
            headerTitle={'同时更新其它商品(填入 product id)：'}
            buttonTitle={'Save'}
            buttonAction={onSave}
          /> 
          <CreatableSelector values={pids} onSelect={setProductIds} placeholder='product ids' />
        </>
      )}
      <ProductRichTextEditor value={value} onChange={onChange} readOnly={readOnly} />
    </div>
  )
}

export default ProductRichTextSection
